import apiClient from './client';

export interface AiToolFeatureRow {
  id: string;
  name: string;
  description: string;
  model: string | null;
  prompt: string;
}

export interface AiToolsConfigResponse {
  features: AiToolFeatureRow[];
}

export interface OpenAiModelOption {
  id: string;
}

export const getAiToolsConfig = async (): Promise<AiToolsConfigResponse> => {
  const response = await apiClient.get<{ success: boolean; data: AiToolsConfigResponse }>(
    '/admin/ai-tools/config',
  );
  return response.data.data;
};

export const updateAiToolsConfig = async (
  payload: Record<string, { model: string | null; prompt: string }>,
): Promise<AiToolsConfigResponse> => {
  const response = await apiClient.put<{ success: boolean; data: AiToolsConfigResponse }>(
    '/admin/ai-tools/config',
    { features: payload },
  );
  return response.data.data;
};

export const getOpenAiModels = async (): Promise<OpenAiModelOption[]> => {
  const response = await apiClient.get<{
    success: boolean;
    data: { models: OpenAiModelOption[] };
  }>('/admin/ai-tools/models');
  return response.data.data.models;
};
